import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Avant de remplacer le cordon ou l&apos;enrouleur, nos techniciens vérifient toujours la cause exacte du dysfonctionnement. Parfois, le problème ne vient pas de ces pièces elles-mêmes, mais d&apos;un guidage défectueux, d&apos;un mauvais réglage de tension ou d&apos;une attache usée. Remplacer sans régler la cause sous-jacente conduirait à une nouvelle usure prématurée.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nous inspectons l&apos;ensemble du mécanisme : l&apos;état de l&apos;enrouleur, le bon alignement du guidage, la fluidité des glissières du tablier et l&apos;absence de point dur. Si le problème vient d&apos;une pièce autre que le cordon ou l&apos;enrouleur, nous vous proposons la réparation adaptée pour une solution durable.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Notre approche est simple : diagnostiquer avant d&apos;intervenir, pour ne remplacer que ce qui est nécessaire et vous éviter des frais inutiles. C&apos;est aussi cela notre engagement de réparateur professionnel à Strasbourg.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Technician%20performing%20a%20detailed%20diagnostic%20inspection%20on%20a%20roller%20shutter%20cord%20mechanism%20using%20precision%20tools%20in%20a%20clean%20workshop%20environment%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography&width=700&height=520&seq=cord-diag&orientation=landscape" alt="Diagnostic d'un cordon de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}